import { createErrorNotifier } from "../errorNotifier";

const errorNotifier = createErrorNotifier("OTHER");

export default errorNotifier;
